import { useWidget } from '@telescope/cassini-hooks';
import { Box, Container, Image, Spacer, useBreakpointValue } from '@telescope/cassini-ui';
import { Open, Closed } from 'generated-types/widget';

export const Header = () => {
  const { data } = useWidget({ select: (data: Open | Closed) => data.snapshot.snapshot_views.header });
  const { content, settings, styles } = data!;

  const breakpoint = useBreakpointValue(['base', 'md', 'lg']) as string;
  
  if (!settings.isVisible) {
    return <Spacer p={{base: 0, lg: 4}}/>
  };

  // TODO: Once finalized, this should be added to Cassini as a new component
  return (
    <Container
      as="header"
      className="cassini-header"
      centerContent
      p={0}
      {...styles.headerContainer}
      maxW={settings.isFullWidth ? 'full' : 'app'}>
      <Box className="cassini-header__image-container" w="100%" maxW="app" {...styles.imageContainer}>
        <Image className="cassini-header__image" alt="" {...content.backgroundImage[breakpoint]} {...styles.image} />
      </Box>
    </Container>
  );
};
